import React from 'react';

import TextField from '@mui/material/TextField';
import Input from '@mui/material/Input';
import Tooltip from '@mui/material/Tooltip';

import { connect } from 'react-redux'

import { saveImage } from '../../actions';

const ImageProps = ({ content, onSaveImage }) => {

    const [src, setSrc] = React.useState(content.config.src);
    const [width, setWidth] = React.useState(content.config.width);
    const [widthError, setWidthError] = React.useState(false);

    const handleTextChange = (name) => event => {
        const newValue = event.target.value;
        if (name === 'src') {
            setSrc(newValue);
            onSaveImage(content.id, { src: newValue, width });
        } else if (name === 'width') {
            setWidthError(false);
            setWidth(newValue);
            onSaveImage(content.id, { src, width: newValue });
        }
    };

    // type="number" silently rejects non-numeric keypresses without firing onChange,
    // so we detect them at keydown time instead.
    const handleWidthKeyDown = (event) => {
        const key = event.key;
        if (key.length === 1 && !/[\d.\-+eE]/.test(key) && !event.ctrlKey && !event.metaKey) {
            setWidthError(true);
        }
    };

    const handleChangeImage = (evt) => {
        const reader = new FileReader();
        const file = evt.target.files[0];

        reader.onload = function (upload) {
            const newSrc = upload.target.result;
            setSrc(newSrc);
            onSaveImage(content.id, { src: newSrc, width });
        };
        reader.readAsDataURL(file);
    };

    return (
        <div>
            <div>
                <Tooltip title="Upload a new image from your computer">
                    <Input type="file" name="file"
                        id="file"
                        fullWidth
                        onChange={handleChangeImage}
                    />
                </Tooltip>
            </div>
            <div>
                <TextField
                    label="Image src"
                    value={src}
                    fullWidth
                    onChange={handleTextChange('src')}
                    margin="normal"
                />
            </div>
            <div>
                <TextField
                    label="Width"
                    value={width}
                    fullWidth
                    onChange={handleTextChange('width')}
                    onKeyDown={handleWidthKeyDown}
                    margin="normal"
                    type="number"
                    error={widthError}
                    helperText={widthError ? 'Width must be a numeric value' : ''}
                />
            </div>
        </div>
    )
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onSaveImage: (rowId, value) => {
            dispatch(saveImage({ rowId, value }))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(ImageProps);